 import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Collapse,
  IconButton,
  Box,
  Typography,
  TableFooter,
  TablePagination
} from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);


const PurchaseTable = ({ rows, summary, themeColors }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (_, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const displayRows = rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <TableContainer
  component={Paper}
  sx={{
    maxHeight: "65vh",
    border: 2,        // 1px border
    borderColor: "divider", // optional: MUI divider color
    borderRadius: 1,  // optional: rounded corners
  }}
>
      <Table stickyHeader>
        <TableHead sx={{ backgroundColor: themeColors.blueAccent[700] }}>
          <TableRow>
            <TableCell />
            <TableCell>Purchase Date</TableCell>
            <TableCell>Supplier</TableCell>
            <TableCell>Warehouse</TableCell>
            <TableCell>Total After Discount</TableCell>
            <TableCell>VAT</TableCell>
            <TableCell>Withholding</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {displayRows.map((row) => (
            <PurchaseRow key={row.id} row={row} themeColors={themeColors} />
          ))}
        </TableBody>

        {/* Totals Row */}
        <TableFooter>
          <TableRow sx={{ backgroundColor: themeColors.primary[400] }}>
            <TableCell colSpan={4} align="right" sx={{ fontWeight: "bold" }}>
              Totals:
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>
              {summary.totalPrice?.toLocaleString() || 0}
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>
              {summary.totalVAT?.toLocaleString() || 0}
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>
              {summary.totalWithholding?.toLocaleString() || 0}
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>

      {/* Pagination */}
      <TablePagination
        component="div"
        count={rows.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25]}
      />
    </TableContainer>
  );
};

const PurchaseRow = ({ row, themeColors }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow hover sx={{ cursor: "pointer" }}>
        <TableCell>
          <IconButton size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>

        <TableCell>{dayjs.utc(row.purchaseDate).format("YYYY-MM-DD")}</TableCell>

        <TableCell>{row.supplier}</TableCell>
        <TableCell>{row.warehouse}</TableCell>
        <TableCell>{row.totalVatedAfterDiscount}</TableCell>
        <TableCell>{row.vat}</TableCell>
        <TableCell>{row.withholdingAmount}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 2 }}>
              <Typography variant="subtitle1" gutterBottom>
                Items
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Item</TableCell>
                    <TableCell>Unit</TableCell>
                    <TableCell align="right">Qty</TableCell>
                    <TableCell align="right">Unit Price</TableCell>
                    <TableCell align="right">Bonus</TableCell>
                    <TableCell>Sponsor</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.items?.map((item, idx) => (
                    <TableRow key={idx} sx={{ "&:last-child td": { border: 0 } }}>
                      <TableCell>{item.name}</TableCell>
                      <TableCell>{item.unit}</TableCell>
                      <TableCell align="right">{item.quantity}</TableCell>
                      <TableCell align="right">
                        {Number(item.unitPrice).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}
                      </TableCell>
                      <TableCell align="right">{item.bonus > 0 ? item.bonus : "-"}</TableCell>
                      <TableCell>{item.sponsor || "-"}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default PurchaseTable;